import { useId } from 'react'

/**
 * The Marble mark — a vein seam cut at 32° through the slab, carrying the
 * brand gradient. Taken verbatim from the logo pack's `marble-mark-transparent`
 * (cms/public/images/marble-logo, "Direction 1a"), which is its source of truth.
 *
 * THE SEAM, NOT THE TILE. The pack's README: "On a pure --ink background the
 * tile reads only by its hairline." This renders on a grid bar that is light in
 * one theme and ink in the other, so one asset has to read on both. The seam is
 * mid-tone teal→blue and does; the tile does not.
 *
 * PLATFORM chrome, deliberately, and NOT `BrandTokens.logo`. The top-left lockup
 * is the DEPLOYMENT's identity, resolved from `platform|brand` — a customer's
 * console wears their mark there. This is the platform's own affordance: the
 * button that opens the command palette for whatever you are looking at, and it
 * is Marble everywhere because every deployment IS Marble.
 *
 * Gradient ids come from `useId`: two marks on one page (a grid and its nested
 * child grid) would otherwise both reference the first one's `<defs>`, and in
 * some browsers the second renders unpainted.
 */
export function MarbleMark({ size = 18, className }: { size?: number; className?: string }) {
  const uid = useId()
  const grad = `mm-g-${uid}`
  const clip = `mm-c-${uid}`
  return (
    <svg
      viewBox="0 0 512 512" width={size} height={size} fill="none"
      className={className} aria-hidden="true" focusable="false"
    >
      <defs>
        <linearGradient id={grad} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#54F2D2" />
          <stop offset=".33" stopColor="#42E0C8" />
          <stop offset=".66" stopColor="#18B7B1" />
          <stop offset="1" stopColor="#4FA9FF" />
        </linearGradient>
        <clipPath id={clip}>
          <rect x="0" y="0" width="512" height="512" rx="120.9856" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clip})`}>
        <rect
          x="-36.992" y="-435.2" width="73.984" height="870.4"
          transform="translate(256 256) rotate(32)" fill={`url(#${grad})`}
        />
      </g>
    </svg>
  )
}
